function setVH() {
  // 获取视口高度并将其设置为一个CSS Custom Property
  const vh = window.innerHeight * 0.01;
  document.documentElement.style.setProperty('--vh', `${vh}px`);
  document.documentElement.style.setProperty(
    '--vhmax',
    `${window.innerHeight}px`,
  );
}

// 初始化设置
setVH();

// 监听窗口大小变化事件
window.addEventListener('resize', setVH);

// 监听设备方向变化事件
window.addEventListener('orientationchange', setVH);
